// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
export const countryToFlag = (iso2: string): string => {
  return typeof String.fromCodePoint !== 'undefined'
    ? iso2.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : iso2;
};
